import { render } from "./CalendarPage.vue?vue&type=template&id=d96c16ca&scoped=true"
import script from "./CalendarPage.vue?vue&type=script&lang=js"
export * from "./CalendarPage.vue?vue&type=script&lang=js"

import "./CalendarPage.vue?vue&type=style&index=0&id=d96c16ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96c16ca"]])

export default __exports__